import { z } from 'zod'

import { category as BudgetCategory } from '@/__generated__/requests'

export const budgetFormSchema = z.object({
  category: z.nativeEnum(BudgetCategory),
  monthlyAmount: z.number().min(0),
})
